import GoogleAnalytics from './common/GoogleAnalytics'
import log from './common/Logger';
import _ from 'lodash';

class EFEGoogleAnalytics extends GoogleAnalytics {

    init(options = null) {
        if (window.ga) {
            if (this.isInit) return;
            if (window.ga) {
                this.isInit = true;
                log.debug(`GA::init - tracking page with ${this.trackerId}`);
                _.forEach(this.gaq, gaqCmd => {
                    window.ga(gaqCmd[0], gaqCmd[1]);
                });
            } else {
                log.warn(`Analytics::init - no ga object found, skipping`)
            }
        } else {
            log.warn(`Analytics::init - no ga object found, skipping`)
        }
    }

    onAfterInit() {
        super.onAfterInit();
        this.send();
    }


}
const instance = new EFEGoogleAnalytics('UA-5853865-1', 'e4e_dev');
export default instance;
